import axios from "axios";

import { IGameData } from "@/shared/model/360/game-data.model";

const baseApiUrl = "api/game-data";

export default class GameDataService {
  public findEncrypted(id: number): Promise<IGameData> {
    return new Promise<IGameData>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/find-encrypted/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
